// src/services/lab/pedagogieService.js
import api from '../api';

const BASE = 'pedagogie/';

// ── Présences ──

/**
 * Feuille d'appel d'une session à une date : TOUS les inscrits, avec leur
 * présence du jour si elle est déjà saisie. C'est l'écran de saisie réel.
 */
export const getFeuilleAppel = async (sessionId, date) => {
  const res = await api.get(`${BASE}appel/${sessionId}/`, { params: { date } });
  return res.data;
};

/** Saisie groupée : une requête pour toute la classe, pas une par apprenant. */
export const saisirAppel = async (date, presences) => {
  const res = await api.post(`${BASE}appel/saisir/`, { date, presences });
  return res.data;
};

export const getPresences = async (params = {}) => {
  const res = await api.get(`${BASE}presences/`, { params });
  return res.data;
};

export const deletePresence = async (id) => {
  const res = await api.delete(`${BASE}presences/${id}/`);
  return res.data;
};

// ── Notes ──
export const getNotes = async (params = {}) => {
  const res = await api.get(`${BASE}notes/`, { params });
  return res.data;
};

export const createNote = async (data) => {
  const res = await api.post(`${BASE}notes/`, data);
  return res.data;
};

export const updateNote = async (id, data) => {
  const res = await api.patch(`${BASE}notes/${id}/`, data);
  return res.data;
};

export const deleteNote = async (id) => {
  const res = await api.delete(`${BASE}notes/${id}/`);
  return res.data;
};

export const publierNotes = async (ids) => {
  const res = await api.post(`${BASE}notes/publier/`, { ids });
  return res.data;
};

export const TYPES_PRESENCE = [
  { value: 'present', label: 'Présent', couleur: '#22c55e', icone: 'fa-check' },
  { value: 'retard',  label: 'En retard', couleur: '#f59e0b', icone: 'fa-clock' },
  { value: 'absent',  label: 'Absent', couleur: '#ef4444', icone: 'fa-xmark' },
];

export const TYPES_EVALUATION = [
  { value: 'devoir',        label: 'Devoir' },
  { value: 'examen',        label: 'Examen' },
  { value: 'projet',        label: 'Projet' },
  { value: 'participation', label: 'Participation' },
  { value: 'td',            label: 'Travaux dirigés' },
];

export const STATUTS_NOTE = [
  { value: 'en_attente', label: 'En attente' },
  { value: 'publiee',    label: 'Publiée' },
  { value: 'archivee',   label: 'Archivée' },
];
